import Hero from "../Component/Hero";
import PengajuanPinjaman from "../Component/PengajuanPinjaman";
import PersyaratanPinjaman from "../Component/PersyaratanPinjaman";
import React from "react";
import CardDokumenPendukung from "../Component/CardDokumenPendukung";
import Table from "../Component/Table";

function InventoryFinancing() {
    return (
        <>
            <div>
                <Hero
                    imageClass='inventory-financing'
                    title='<em>Inventory Financing</em>'
                    subTitle='P I N J A M A N &emsp;P R O D U K T I F'
                    explanation='
                        Fasilitas pinjaman yang ditawarkan kepada Pelaku Usaha untuk menjaga <em>cash flow</em> dengan menggunakan barang persediaan <em>(inventory)</em> sebagai jaminan.'
                    buttonText='AJUKAN PINJAMAN'
                    buttonCompanyWeb={true}
                />
                <Table type='produktif' title='inventory'/>
                <PersyaratanPinjaman type='produktif'/>
                <CardDokumenPendukung type='produktif' product='inventory'/>
                <PengajuanPinjaman type='produktif'/>
            </div>
        </>
    );
}

export default InventoryFinancing;
